import { render, staticRenderFns } from "./governmentAffairs.vue?vue&type=template&id=73507cfe&scoped=true&"
import script from "./governmentAffairs.vue?vue&type=script&lang=js&"
export * from "./governmentAffairs.vue?vue&type=script&lang=js&"
import style0 from "./governmentAffairs.vue?vue&type=style&index=0&id=73507cfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73507cfe",
  null
  
)

export default component.exports